import React, { Fragment } from 'react'
import { animated, config, useTransition } from 'react-spring'


const WithTransition = (panels, index = 0) => {

    const transitions = useTransition(
        panels[index], 
        item => item.id, {
            from:{ opacity: 0, transform: "translate3d(100%, 0 ,0)" },
            enter:{ opacity: 1, transform: "translate3d(0%, 0, 0)" },
            leave:{ opacity: 0, display:'none', transform: "translate3d(-50%, 0, 0)" },
            config: config.slow
        }
    )

    return(
        <Fragment>
            {transitions.map(({ props, key }) => (
                <animated.div style={props} key={key}>
                {panels[index].component ?
                    React.createElement(panels[index].component, panels[index].props)
                        : panels[index].form
                }
                </animated.div>
            ))}
        </Fragment>
    )
}

export { WithTransition }